import { AppUser } from 'Src/views/App/App';
import axios from 'axios';
import { ALL_LIMIT } from 'Src/consts/table';

export function getDeliveryCharges(user: AppUser, filter) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
    },
  };

  return axios
    .get(`${window.apiBase}/admin/deliveryCharges`, config)
    .then(response => {
      return response.data;
    });
}

export function getAllDeliveryCharges(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where,
          },
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  }

  return axios
    .get(`${window.apiBase}/admin/deliveryCharges`, config)
    .then(response => {
      return response.data;
    });
}

export function getDeliveryChargesCount(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
    };
  }

  return axios
    .get(`${window.apiBase}/admin/deliveryCharges/count`, config)
    .then(response => {
      return response.data;
    });
}

export function addDeliveryCharge(user: AppUser, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .post(`${window.apiBase}/admin/deliveryCharges`, data, config)
    .then(response => {
      return response.data;
    });
}

export function updateDeliveryCharge(
  user: AppUser,
  deliveryChargeId: string,
  data
) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .put(
      `${window.apiBase}/admin/deliveryCharges/${deliveryChargeId}`,
      data,
      config
    )
    .then(response => {
      return response.data;
    });
}

export function deleteDeliveryCharge(user: AppUser, deliveryChargeId: string) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .delete(
      `${window.apiBase}/admin/deliveryCharges/${deliveryChargeId}`,
      config
    )
    .then(response => {
      return response.data;
    });
}
